import { extendsModule, baseFormItem } from 'src/store/base';
import * as types from 'src/store/types';

export default extendsModule(baseFormItem, {
  state: {
    _moduleKey: 'procedural-creative-tracking-url',
    track_url: [],
    action_track_url: [],
    vast_moat: 0,
    vast_double_verify: 0,
    vast_ias: false,
    vast_url: '',
    domain: '',
  },
  getters: {
    formItemData(state) {
      return {
        track_url: state.track_url,
        action_track_url: state.action_track_url,
        vast_moat: state.vast_moat,
        vast_double_verify: state.vast_double_verify,
        vast_ias: state.vast_ias,
        vast_url: state.vast_url,
        domain: state.domain,
      };
    },
  },
  mutations: {
    [types.UPDATE_PCD_TRACK_URL](state, url = '') {
      state.track_url = url;
    },
    [types.UPDATE_PCD_DOMAIN](state, domain = '') {
      state.domain = domain;
    },
    [types.UPDATE_PCD_ACTION_TRACK_URL](state, url = '') {
      state.action_track_url = url;
    },
    [types.UPDATE_PCD_VAST_MOAT](state, url = '') {
      state.vast_moat = url;
    },
    [types.UPDATE_PCD_VAST_DV](state, url = '') {
      state.vast_double_verify = url;
    },
    [types.UPDATE_PCD_VAST_IAS](state, url = '') {
      state.vast_ias = url;
    },
    [types.UPDATE_PCD_VAST_URL](state, url = '') {
      state.vast_url = url;
    },
  },
  actions: {
    data2State({ commit }, formData) {
      const data = {
        track_url: formData.track_url,
        action_track_url: formData.action_track_url,
        vast_moat: formData.vast_moat,
        vast_double_verify: formData.vast_double_verify,
        vast_ias: formData.vast_ias,
        vast_url: formData.vast_url,
        domain: formData.domain,
      };

      commit('update', data);
    },
  },
});
